<template>
  <div>
    <v-dialog scrollable v-model="dialogUserdetail" persistent max-width="600">
      <v-card>
        <v-toolbar dark dense elevation="0" color="primary">
          <v-toolbar-title>Detail User</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-tabs class="mt-2" fixed-tabs  v-model="tab">
            <v-tab>User</v-tab>
            <v-tab>Document</v-tab>
            <v-tab>ROLES</v-tab>
            <v-tab>VA</v-tab>
            <v-tab-item>
              <v-row>
                <v-col cols="12" lg="4" md="4" sm="12">
                  <div class="ma-2">
                    <img  v-if="userdetail.member.memberavatar" alt="xuserlogo" style="width: 150px" :src="userdetail.member.memberavatar"/>
                    <div v-else class="grey lighten-3 rounded-b-lg" style="position: relative;height: 120px">
                      <img alt="xuserlogox" style="width: 100%;position: absolute;height: 100%;margin: auto;margin-top: 10px" src="../assets/Logo-IRS-Market-white.png"/>
                    </div>
                  </div>
                </v-col>
                <v-col cols="12" lg="8" md="8" sm="12">
                  <div class="ma-2">
                    <v-text-field label="Nama" v-model="userdetail.member.membername"></v-text-field>
                    <v-text-field label="Alamat" v-model="userdetail.member.memberaddress"></v-text-field>
                    <v-text-field label="Kontak " v-model="userdetail.member.membercontact"></v-text-field>
                    <v-text-field label="NoTelp Verifikasi" v-model="userdetail.member.memberphone"></v-text-field>
                    <v-text-field label="Email" v-model="userdetail.member.memberemail"></v-text-field>
                    <v-text-field readonly label="Balance" v-model="userdetail.member.memberbalance"></v-text-field>
                    <v-switch v-model="statusSlider" inset label="Aktif">Aktif</v-switch>
                  </div>
                </v-col>
              </v-row>
            </v-tab-item>
            <v-tab-item>
              <div class="ma-2">
                <v-simple-table>
                  <template v-slot:default>
                    <tbody>
                    <tr>
                      <td><img v-if="userdetail.member.memberktp" style="width: 300px;height: 300px" :src="userdetail.member.memberktp"/></td>
                    </tr>
                    <tr>
                      <td><img v-if="userdetail.member.membernpwp" style="width: 300px;height: 300px" :src="userdetail.member.membernpwp"/></td>
                    </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </div>
            </v-tab-item>
            <v-tab-item>
              <div class="ma-2">
                <v-row>
                  <v-col cols="12" ld="6" md="10">
                    <div class="">
                      <v-select
                          clearable
                          label="Role User"
                          item-text="name"
                          item-value="id"
                          v-model="roleid"
                          :items="roles"
                      ></v-select>
                    </div>
                  </v-col>
                  <v-col cols="12" ld="6" md="2">
                    <div class="mt-4">
                      <v-btn elevation="0" @click="tambahRole" x-small class="primary"><v-icon>add</v-icon></v-btn>
                    </div>
                  </v-col>
                </v-row>
                <v-simple-table>
                  <template v-slot:default>
                    <tbody>
                    <tr v-for="item in userdetail.user.roles"
                        :key="item.name">
                      <td>{{ item.id }}</td>
                      <td>{{ item.name }}</td>
                      <td><v-btn @click="deleteROles(item.id)" dark fab x-small elevation="0" class="red"><v-icon small>delete</v-icon></v-btn> </td>
                    </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </div>
            </v-tab-item>
            <v-tab-item>
              <div class="ma-2">
                <v-simple-table>
                  <template v-slot:default>
                    <tbody>
                    <tr v-for="item in userdetail.va"
                        :key="item.nova">
                      <td>{{ item.bank }}</td>
                      <td>{{ item.nova }}</td>
                    </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </div>
            </v-tab-item>
          </v-tabs>
        </v-card-text>
        <v-divider/>
        <v-card-actions>
          <v-btn v-if="userdetail.user.confm===0" elevation="0" dark @click="resendemailAct(userdetail.user.id)" color="accent">Kirim Email Aktivasi</v-btn>
          <v-btn v-if="userdetail.member.statustoko===1 && confmseller===3" elevation="0" dark @click="updateStatusTokoSeller(0)" color="red">Tutup Toko</v-btn>
          <v-btn v-if="userdetail.member.statustoko===0 && confmseller===3" elevation="0" dark @click="updateStatusTokoSeller(1)" color="blue">Buka Toko</v-btn>
          <v-btn v-if="confmseller===2" elevation="0" dark @click="approveSeller(userdetail.member.memberid)" color="blue">Approve Seller</v-btn>
          <v-btn v-if="confmseller>1" elevation="0" dark @click="rejectSeller(userdetail.member.memberid)" color="red">Reject Seller</v-btn>
          <v-spacer/>
          <v-btn elevation="0" dark @click="setdialoguserdetail(false)" color="red">Tutup</v-btn>
          <v-btn elevation="0" dark @click="simpanUser(userdetail.member)" color="primary">SIMPAN</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'DialogDetailUser',
  data: () => ({
    tab: null,
    roleid: 0
  }),
  computed: {
    ...mapState('AdminUserStore', ['dialogUserdetail', 'userdetail', 'roles']),
    confmseller () {
      return parseInt(this.userdetail.member.adminconfirmation)
    },
    statusSlider: {
      get () {
        return this.userdetail.member.memberstatus === 2
      },
      set (val) {
        if (val) {
          this.userdetail.member.memberstatus = 2
        } else {
          this.userdetail.member.memberstatus = 0
        }
      }
    }
  },
  methods: {
    ...mapActions('AdminUserStore', ['setdialoguserdetail', 'resendemailAct', 'updateUser', 'getRoles', 'addUserRole', 'deleteRole', 'approveSeller', 'rejectSeller', 'adminUpdateStatusToko']),
    simpanUser (val) {
      this.updateUser(this.userdetail.member)
    },
    updateStatusTokoSeller (val) {
      this.adminUpdateStatusToko({ memberid: this.userdetail.member.memberid, status: val })
    },
    tambahRole () {
      this.addUserRole({ roleid: this.roleid, userid: this.userdetail.user.id })
    },
    deleteROles (roleid) {
      this.$confirm('Hapus Role ? ', { color: 'red', title: 'Konfirmasi', icon: 'fa-question' }).then(res => {
        if (res) {
          this.deleteRole({ roleid: roleid, userid: this.userdetail.user.id })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
